import type { PaymentMethodFundingSource } from '../../../types/PaymentsButtonViewConfig';
import { MIN_AMOUNT_OF_TOP_LEVEL_BUTTONS, buttonsViewConfig, type PaymentMethodConfig } from '../buttonsViewConfig';

const prioritizedPaymentMethodConfig: PaymentMethodConfig[] = Object.values(buttonsViewConfig).sort(
  (methodA, methodB) => methodA.priority - methodB.priority,
);

const getConnectedPaymentMethodsConfig = (paymentMethods: PaymentMethodFundingSource[]): PaymentMethodConfig[] =>
  prioritizedPaymentMethodConfig.filter((item) => paymentMethods.includes(item.name));

type ExpressButtonsConfig = {
  items: PaymentMethodConfig[];
  onTopLevelCount: number;
};

export const getExpressButtonsConfig = (paymentMethods: PaymentMethodFundingSource[]): ExpressButtonsConfig => {
  const buttonsConfig = getConnectedPaymentMethodsConfig(paymentMethods);

  return {
    items: buttonsConfig,
    onTopLevelCount: buttonsConfig.length,
  };
};

/**
 * Returns buttons config based on 2 groups: button on a Top level
 * and buttons that are inside "More payment options" label
 * https://wix.atlassian.net/browse/PAY-20552
 */
export const getGroupedExpressButtonsConfig = (paymentMethods: PaymentMethodFundingSource[]): ExpressButtonsConfig => {
  const buttonsConfig = getConnectedPaymentMethodsConfig(paymentMethods);
  const buttonGroups = buttonsConfig.reduce(
    (methods, value) => {
      if (value.canBeHidden) {
        methods.rest.push(value);
      } else {
        methods.onTopLevel.push(value);
      }

      return methods;
    },
    {
      onTopLevel: [],
      rest: [],
    },
  );

  return {
    items: [...buttonGroups.onTopLevel, ...buttonGroups.rest],
    onTopLevelCount: Math.max(MIN_AMOUNT_OF_TOP_LEVEL_BUTTONS, buttonGroups.onTopLevel.length),
  };
};
